<template>
  <CRow>
    <CCol col="12" xl="8">
      <CCard>
        <CCardHeader>
          <strong>Γενικά στοιχεία</strong>
        </CCardHeader>
        <CCardBody class="position-relative">
          <CForm>
            <CModal
              class="modalAlert"
              :show.sync="alertIsShown"
              :centered="true"
              size="lg"
            >
              <CAlert
                closeButton
                :show.sync="alertIsShown"
                color="primary"
                fade
              >
                {{ message }}
              </CAlert>
            </CModal>
            <div class="form-row form-group">
              <CCol sm="3" class="requiredLabel">
                Πελάτης
              </CCol>
              <CCol sm="9">
                <multiselect 
                  v-model="client" 
                  id="client" 
                  :options="clients"
                  label="label"
                  @input="selectedClient"
                  track-by="value">
                </multiselect>
              </CCol>
            </div>
            <CInput 
              horizontal 
              type="text" 
              label="Όνομα Πελάτη" 
              id="company_name" 
              placeholder="Όνομα Πελάτη" 
              addLabelClasses="requiredLabel"
              v-model="company_name">
            </CInput>
            <CInput 
              horizontal 
              type="text" 
              label="Όνομα Πελάτη (Αγγλικά)" 
              id="company_name_en" 
              placeholder="Όνομα Πελάτη (Αγγλικά)" 
              addLabelClasses="requiredLabel"
              v-model="company_name_en">
            </CInput>
            <div class="form-row form-group">
              <CCol sm="3" class="requiredLabel">
                Υπηρεσία
              </CCol>
              <CCol sm="9">
                <multiselect 
                  v-model="service" 
                  id="service" 
                  :options="services"
                  label="label"
                  @select="changedService"
                  track-by="value">
                </multiselect>
              </CCol>
            </div>
            <CInput 
              horizontal 
              type="text" 
              label="Υπηρεσία (Αγγλικά)" 
              id="service_en" 
              placeholder="Υπηρεσία (Αγγλικά)" 
              v-model="service_en"
            />
            <CInput 
              horizontal 
              type="text" 
              label="Πεδίο Πιστοποίησης" 
              id="certification_field" 
              placeholder="Πεδίο Πιστοποίησης" 
              v-model="certification_field">
            </CInput>
            <CInput 
              horizontal 
              type="text" 
              label="Πεδίο Πιστοποίησης (Αγγλικά)" 
              id="certification_field_en" 
              placeholder="Πεδίο Πιστοποίησης (Αγγλικά)" 
              v-model="certification_field_en">
            </CInput>
            <CInput
              label="Ημερομηνία Πιστοποίησης"
              type="date"
              v-model="certification_date"
              horizontal
              @change="calculateDate"
              addLabelClasses="requiredLabel"
            />
            <CInput
              label="Ημερομηνία Επαναπιστοποίησης"
              type="date"
              v-model="recertification_date"
              horizontal
            />
            <CInput
              label="Ημερομηνία Τελευταίας Τροποποίησης"
              type="date"
              v-model="modification_date"
              horizontal
            />
            <CInput
              label="Ημερομηνία Λήξης"
              type="date"
              v-model="expiration_date"
              horizontal
              addLabelClasses="requiredLabel"
            />
            <div class="form-row form-group">
              <CCol sm="3" class="requiredLabel">
                Κατάσταση
              </CCol>
              <CCol sm="9">
                <multiselect 
                  v-model="status" 
                  id="status" 
                  :options="statuses"
                  label="label"
                  track-by="value">
                </multiselect>
              </CCol>
            </div>
            <CInput 
              horizontal 
              addLabelClasses="requiredLabel"
              type="text" 
              label="Αριθμός πιστοποιητικού" 
              id="certificate_no" 
              placeholder="Αριθμός πιστοποιητικού" 
              v-model="certificate_no"
            />
            <CInput 
              horizontal 
              type="text" 
              label="Αριθμός πιστοποιητικού (Αγγλικά)" 
              id="certificate_no_en" 
              placeholder="Αριθμός πιστοποιητικού (Αγγλικά)" 
              v-model="certificate_no_en"
            />
            <CInput horizontal addLabelClasses="requiredLabel" type="text" label="Κωδικός" id="password" placeholder="Κωδικός" v-model="password">
              <!--template #append>
                <CButton color="primary" class="zIndex0" @click="generatePassword()">Ανανέωση</CButton>
              </template-->
            </CInput>
            <CButton color="primary" @click="store()">Αποθήκευση</CButton>
            <CButton color="primary" @click="goBack">Πίσω</CButton>
            <CElementCover :opacity="0.8" :boundaries="[{ sides: ['top', 'left'], query: '.card-body' }]" v-show="uploading"/>
          </CForm>
        </CCardBody>
      </CCard>
    </CCol>
  </CRow>
</template>

<script>
import axios from 'axios'
import 'vue-multiselect/dist/vue-multiselect.min.css'
import Multiselect from 'vue-multiselect'
import moment from 'moment'

export default {
  name: 'CreateCertification',
  components: {
    Multiselect,
  },
  props: {
    caption: {
      type: String,
      default: 'Create Certification'
    },
  },
  data: () => {
    return {
      showMessage: false,
      message: '',
      dismissSecs: 7,
      dismissCountDown: 0,
      showDismissibleAlert: false,
      client: '',
      status: '',
      alertIsShown: false,
      service: '',
      clients: [],
      statuses: [],
      services: [],
      uploading: false,
      certification_date: new Date().toISOString().substr(0, 10),
      expiration_date: moment(new Date()).add(3, 'y').subtract(1, "days").format('YYYY-MM-DD'),
      certification_field: '',
      certification_field_en: '',
      password: '',
      company_name: '',
      company_name_en: '',
      modification_date: '',
      isActive: true,
      certificate_no: '',
      certificate_no_en: '',
      service_en: '',
      recertification_date: null
    }
  },
  computed: {
    alertModal: {
      get() {
        return this.dismissCountDown > 0;
      },
      set() {
        this.dismissCountDown = 0;
      }
    }
  },
  watch: {
    alertIsShown: function(newVal, oldVal) {
      if (! newVal && this.saved) {
        this.$emit('closed-alert');
      }
    }
  },
  methods: {
    goBack() {
      this.$router.go(-1)
      // this.$router.replace({path: '/clients'})
    },
    generatePassword() {
      const characters ='abcdefghijklmnopqrstuvwxyz0123456789';
      let result = '';
      const charactersLength = characters.length;
      for ( let i = 0; i < 8; i++ ) {
          result += characters.charAt(Math.floor(Math.random() * charactersLength));
      }

      this.password = result;
    },
    calculateDate() {
      this.expiration_date = moment(this.certification_date).add(3, 'y').subtract(1, "days").format('YYYY-MM-DD');
    },
    changedService(service) {
      this.certification_field = service.certification_field;
    },
    store() {
      let self = this;
      let client_id = null;
      if (self.client) {
        client_id = self.client.value;
      }

      let service_id = null;
      if (self.service) {
        service_id = self.service.value;
      }

      let status_id = null;
      if (self.status) {
        status_id = self.status.value;
      }
      self.uploading = true;
      axios.post('/api/certifications?token=' + localStorage.getItem("api_token"),
      {
        certification_date: self.certification_date,
        recertification_date: self.recertification_date,
        expiration_date: self.expiration_date,
        client: client_id,
        certification_field: self.certification_field,
        password: self.password,
        status: status_id,
        service: service_id,
        certification_field_en: self.certification_field_en,
        company_name: self.company_name,
        company_name_en: self.company_name_en,
        modification_date: self.modification_date,
        isActive: self.isActive,
        certificate_no: self.certificate_no,
        certificate_no_en: self.certificate_no_en,
        service_en: self.service_en
      })
      .then(function (response) {
        self.message = 'Επιτυχής έκδοση πιστοποιητικού.';
        self.showAlert();
        self.uploading = false;
      }).catch(function (error) {
          self.uploading = false;
          if(error.response.data.message == 'The given data was invalid.'){
            self.message = '';
            for (let key in error.response.data.errors) {
              if (error.response.data.errors.hasOwnProperty(key)) {
                self.message += error.response.data.errors[key][0] + '  ';
              }
            }
            self.showAlert();
          }else{
            self.$router.push({ path: '/login' }); 
          }
      });
    },
    countDownChanged (dismissCountDown) {
      this.dismissCountDown = dismissCountDown
    },
    showAlert () {
      this.alertIsShown = true
    },
    selectedClient() {
      this.services = this.client.services.map((item) => {
        return {
          value: item.id,
          label: item.name,
          certification_field: item.pivot.certification_field
        };
      });
      this.service = this.services[0];
      this.company_name = this.client.label;
      this.company_name_en = this.client.company_name_en;
      this.certification_field = this.service.certification_field;
    }
  },
  mounted: function(){
    let self = this;
    axios.get('/api/certifications/create?token=' + localStorage.getItem("api_token"))
    .then(function (response) {
      self.clients = response.data.clients.map((item) => {
        return {
          value: item.id,
          label: item.company,
          services: item.services,
          company_name_en: item.company_en,
        }
      });
      self.statuses = response.data.statuses.map((item) => {
        return {
          value: item.id,
          label: item.name
        }
      });
      self.status = self.statuses[0];
      self.generatePassword();
    }).catch(function (error) {
        console.log(error);
        self.$router.push({ path: '/login' });
    });
  }
}


</script>
